export const dataObj =
{

    "R1": "Test the quality of parts before shipment",
    "R2": "Lay brick or tile",
    "R3": "Work on an offshore oil-drilling rig",
    "R4": "Assemble electronic parts",
    "R5": "Operate a grinding machine in a factory",
    "R6": "Fix a broken faucet",
    "R7": "Assemble products in a factory",
    "R8": "Install flooring in houses",
    "I1": "Study the structure of the human body",
    "I2": "Study animal behavior",
    "I3": "Do research on plants or animals",
    "I4": "Develop a new medical treatment or procedure",
    "I5": "Conduct biological research",
    "I6": "Study whales and other types of marine life",
    "I7": "Work in a biology lab",
    "I8": "Make a map of the bottom of an ocean",
    "A1": "Conduct a musical choir",
    "A2": "Direct a play",
    "A3": "Design artwork for magazines",
    "A4": "Write a song",
    "A5": "Write books or plays",
    "A6": "Play a musical instrument",
    "A7": "Perform stunts for a movie or television show",
    "A8": "Design sets for plays",
    "S1": "Give career guidance to people",
    "S2": "Do volunteer work at a non-profit organization",
    "S3": "Help people who have problems with drugs or alcohol",
    "S4": "Teach an individual an exercise routine",
    "S5": "Help people with family-related problems",
    "S6": "Supervise the activities of children at a camp",
    "S7": "Teach children how to read",
    "S8": "Help elderly people with their daily activities",
    "E1": "Sell restaurant franchises to individuals",
    "E2": "Sell merchandise at a department store",
    "E3": "Manage the operations of a hotel",
    "E4": "Operate a beauty salon or barber shop",
    "E5": "Manage a department within a large company",
    "E6": "Manage a clothing store",
    "E7": "Sell houses",
    "E8": "Run a toy store",
    "C1": "Generate the monthly payroll checks for an office",
    "C2": "Inventory supplies using a hand-held computer",
    "C3": "Use a computer program to generate customer bills",
    "C4": "Maintain employee records",
    "C5": "Compute and record statistical and other numerical data",
    "C6": "Operate a calculator",
    "C7": "Handle customers' bank transactions",
    "C8": "Keep shipping and receiving records"

};


export const dataObjKeys = [
    "R1", "R2", "R3", "R4", "R5", "R6", "R7", "R8",
    "I1", "I2", "I3", "I4", "I5", "I5", "I7", "I8",
    "A1", "A2", "A3", "A4", "A5", "A6", "A7", "A8",
    "S1", "S2", "S3", "S4", "S5", "S6", "S7", "S8",
    "E1", "E2", "E3", "E4", "E5", "E6", "E7", "E8",
    "C1", "C2", "C3", "C4", "C5", "C6", "C7", "C8"]